import { Card, Input, Button, Tooltip, Select, Space } from "antd";
import { FaSearch, FaPlus, FaChartLine, FaTimes } from "react-icons/fa";
const { Option } = Select;

export function ParticipantesFilter({
  searchTerm,
  setSearchTerm,
  filterEstado,
  setFilterEstado,
  filterSexo,
  setFilterSexo,
  filterDepartamento,
  setFilterDepartamento,
  filterMunicipio,
  setFilterMunicipio,
  estadosBackend,
  departamentos,
  municipios,
  showCharts,
  setShowCharts,
  permissionInsert,
  handleCreate,
  hasActiveFilters,
  onClearFilters
}) {

  return (
    <Card className="mb-6" style={{ borderRadius: 12, marginTop: 10 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 180px 180px 180px 140px 290px",
          gap: "12px",
          alignItems: "center",
          width: "100%",
          minWidth: "100%"
        }}
      >
        <div style={{ width: "100%" }}>
          <Input
            prefix={<FaSearch style={{ fontSize: "17px" }} />}
            placeholder="Buscar por nombre o cc"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ 
              padding: 10, 
              width: "100%",
              minWidth: "100%"
            }}
          />
        </div>
        <div style={{ width: "180px" }}>
          <Select
            value={filterEstado}
            onChange={setFilterEstado}
            style={{ 
              width: "180px", 
              height: 45 
            }}
            placeholder="Estado"
          >
            <Option value="todos">Estados</Option>
            {estadosBackend?.map((est, index) => {
              const key = est.id || `estado-${index}`;
              const valor = est.codigo;
              const label = est.nombre;
              return (
                <Option key={key} value={valor}>
                  {label}
                </Option>
              );
            })}
          </Select>
        </div>
        <div style={{ width: "180px" }}>
          <Select
            value={filterDepartamento}
            onChange={setFilterDepartamento}
            style={{ 
              width: "180px",
              height: 45 
            }}
            placeholder="Departamento"
          >
            <Option value="todos">Departamentos</Option>
            {departamentos?.map((depto, index) => {
              const key = depto.oid || `depto-${index}`;
              const valor = depto.oid;
              const label = depto.departamento;
              return (
                <Option key={key} value={valor}>
                  {label}
                </Option>
              );
            })}
          </Select>
        </div>
        <div style={{ width: "180px" }}>
          <Select
            value={filterMunicipio}
            onChange={setFilterMunicipio}
            style={{ 
              width: "180px", 
              height: 45 
            }}
            placeholder="Municipio"
            disabled={!filterDepartamento || filterDepartamento === "todos"}
          >
            <Option value="todos">Municipios</Option>
            {municipios?.map((mun, index) => {
              const key = mun.oid || mun.id || `mun-${index}`;
              const valor = mun.oid || mun.id;
              const label = mun.municipio || mun.nombre;
              return (
                <Option key={key} value={valor}>
                  {label}
                </Option>
              );
            })}
          </Select>
        </div>
        <div style={{ width: "140px" }}>
          <Select
            value={filterSexo}
            onChange={setFilterSexo}
            style={{ 
              width: "140px",
              height: 45 
            }}
            placeholder="Género"
          >
            <Option value="todos">Géneros</Option>
            <Option value="M">Masculino</Option>
            <Option value="F">Femenino</Option>
          </Select>
        </div>
        <div style={{ width: "320px" }}>
          <Space>
            <Tooltip title="Mostrar / Ocultar Gráficas">
              <Button
                icon={<FaChartLine />}
                onClick={() => setShowCharts(!showCharts)}
                style={{
                  borderColor: "#0968C6",
                  color: "#0968C6",
                  height: 45,
                  whiteSpace: "nowrap",
                  width: "auto"
                }}
              >
                {showCharts ? "Ocultar" : "Mostrar"}
              </Button>
            </Tooltip>
            {hasActiveFilters && (
              <Tooltip title="Limpiar filtros">
                <Button
                  icon={<FaTimes />}
                  onClick={onClearFilters}
                  style={{
                    borderColor: "#ff4d4f",
                    color: "#ff4d4f",
                    height: 45,
                    whiteSpace: "nowrap",
                    width: "auto"
                  }}
                >
                  Limpiar
                </Button>
              </Tooltip>
            )}
            {permissionInsert && (
              <Tooltip title="Nuevo Participante">
                <Button
                  icon={<FaPlus />}
                  onClick={handleCreate}
                  style={{
                    borderColor: "#0968C6",
                    color: "#0968C6",
                    height: 45,
                    whiteSpace: "nowrap",
                    width: "auto"
                  }}
                >
                  Nuevo
                </Button>
              </Tooltip>
            )}
          </Space>
        </div>
      </div>
    </Card>
  );
}